import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9 29.8c1.4.7 3.5 1.1 5.6 1.1s4.2-.4 5.6-1.1c1.8-.9 2.1-2 2.1-2.7v-6.9L45 14v-2.7l-14.8 6.2v-2.8c3.7-1.4 6.1-3.8 6.1-6.6.1-4.5-6-8.1-13.8-8.1S8.6 3.5 8.6 8s2.4 5.2 6.1 6.6v9.2L0 30v14.9h2.5V33.6L18 39.5v5.4h2.5v-5.6L45 29v-2.7L18.9 37.2 3.3 31.3l11.4-4.7v.4c0 .8.4 1.9 2.1 2.7ZM11.2 8c0-2.6 4.7-5.5 11.4-5.5S34 5.4 34 8s-4.7 5.4-11.4 5.4S11.2 10.5 11.2 8Zm6.1 14.8v-7.4c1.6.4 3.4.6 5.2.6s3.6-.2 5.2-.6V27s-.1.2-.7.6c-1.1.5-2.8.8-4.5.8s-3.5-.3-4.5-.8c-.6-.3-.7-.5-.7-.5v-4.2Z",
			className: "icon-fill-primary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.1 10.2c1.4-.7 1.7-1.6 1.7-2.2 0-2.1-3.3-3.1-6.3-3.1s-6.3 1-6.3 3.1.3 1.5 1.7 2.2 2.8.9 4.6.9 3.5-.3 4.6-.9Z",
			className: "icon-fill-secondary"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.2 10.8c1.8-.9 2.1-2 2.1-2.7 0-2.6-4-3.8-7.8-3.8s-7.7 1.2-7.7 3.8.4 1.9 2.1 2.7 3.5 1.1 5.6 1.1 4.2-.4 5.6-1.1ZM17.3 8c.3-.4 2.1-1.3 5.2-1.3s4.9.9 5.2 1.3c0 0-.2.3-.7.5-1.1.5-2.7.8-4.5.8S19 9 18 8.5c-.4-.2-.6-.4-.7-.5Z",
			className: "icon-fill-primary"
		})
	]
});
export default SvgIcon;
